<template>
  <Navbar />
  <router-view/>
  <Sidebar />
  <Footer />
  <Toasts />
</template>

<script>
import Navbar from '@/components/nav/Navbar'
import Sidebar from '@/components/sidebar/Sidebar'
import Footer from '@/components/footer/Footer'
import Toasts from '@/components/toast/Toasts'
import { useHead } from '@vueuse/head'

export default {
  components: {
    Navbar,
    Footer,
    Sidebar,
    Toasts
  },
  created() {
    useHead({
      // Can be static or computed
      title: "OGQ GYN Deep Manager",
      meta: [
        {
          name: `description`,
          content: `OGQ GYN의 딥러닝 기반 이미지 인식 기술을 활용한 AI 솔루션`,
        },
        {
          property: 'og:site_name',
          content: "OGQ GYN Deep Manager"
        },
        {
          property: 'og:title',
          content: "OGQ GYN Deep Manager"
        },
        {
          name: `og:description`,
          content: `OGQ GYN의 딥러닝 기반 이미지 인식 기술을 활용한 AI 솔루션`,
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          property: 'og:image',
          content: this.$IMG(`assets/images/home_mast.png`)
        },
        {
          property: 'twitter:card',
          content: "summary_large_image"
        },
      ],
    })
  },
}

</script>

<style lang="scss">
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

html, body {
  font-family: 'Red Hat Display', 'Pretendard', sans-serif;
  font-size: 100%;
  color: var(--gray-900);
  margin: 0;
  padding: 0;
  &.is-grabbing {
    cursor: grabbing;
  }
  &.is-sidebar-open {
    height: 100%;
    overflow: hidden;
  }
}

html {
  height: 100%;
}

body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#app {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

*, *:before, *:after {
  box-sizing: border-box;
}

button.btn-close {
  font-family: inherit;
  border: 0;
  background-color: white;
  border-radius: 5px;
  &:hover {
    background-color: var(--gray-200)
  }
  &:active {
    background-color: var(--gray-300)
  }
}

</style>
